import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import axios from '../../utils/axiosInterceptor';

import { Box, Divider, Typography, Grid, Container, CircularProgress,
TableBody, TableCell, TableHead, TableRow, Table, TableContainer, } from '@mui/material';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';
import { getDate } from '../../utils/functions/Utils';

const SeguimientoProducto = () => {

    const auth = useSelector((state) => state.auth);
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [product, setProduct] = useState({});

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    // get id from url
    let { id } = useParams()

    useEffect(() => {
        if (!['Admin', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Movimientos del producto';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    const getData = async () => {
        setLoading(true);
        try {
            let res = await axios.get(`/api/inventories/productHistory/${id}`);
            setData(res.data.productHistory);
            setProduct(res.data.product);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    }

    useEffect(() => {
        getData();
    }, []);

    const productDetails = () => {
        if(product._id !== undefined) {
            return(
                <>
                    <Divider className='my-3' textAlign="left">
                        <CustomChip variant='outlined' estatus='AUTORIZADO' label='Detalles del producto' className='text-bold' />
                    </Divider>

                    <div style={{ maxHeight: '90px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}>
                        <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                            <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Clave del producto:</p>
                            <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{product.clave ? product.clave : ''}</p>
                        </div>
                        <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                            <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Nombre:</p>
                            <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{product.name ? product.name : ''}</p>
                        </div>
                        <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                            <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Descripción:</p>
                            <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{product.descripcion ? product.descripcion : ''}</p>
                        </div>
                        <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                            <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Marca:</p>
                            <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{product.marca ? product.marca : ''}</p>
                        </div>
                        <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                            <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Modelo:</p>
                            <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{product.modelo ? product.modelo : ''}</p>
                        </div>
                        <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                            <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Cantidad disponible:</p>
                            <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{product.cantidad ? product.cantidad : ''}</p>
                        </div>
                    </div>
                </>
            )
        }
    }

    const renderHistory = () => {  
        if (loading) {
            return(
                <Container style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <CircularProgress />
                </Container>
            )
        } else {
            if(data.length > 0) {
                return(
                    <Container maxWidth='xxl'>
                        <Typography variant='h4' style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 700 }}>Movimientos del producto</Typography>

                        {productDetails()}

                        <Divider className='my-3' textAlign="center">
                            <CustomChip variant='outlined' estatus='AUTORIZADO' label='Historial de movimientos' className='text-bold' />
                        </Divider>
                            {
                                data.map((item, index) => (
                                    <Box key={item._id}>
                                        {
                                            item.salida ? 
                                            <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                <Typography variant='h6'>Tipo de movimiento: </Typography>
                                                <Typography variant='h6' style={{margin: '0px 12px'}} color='secondary'>{item.tipoMovimiento}</Typography>
                                                <Typography variant='body2' color='secondary'><i className='fad fa-sign-out fa-2x'></i></Typography>
                                            </Box> :
                                            <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                <Typography variant='h6'>Tipo de movimiento: </Typography>
                                                <Typography variant='h6' style={{margin: '0px 12px'}} color='primary'>{item.tipoMovimiento}</Typography>
                                                <Typography variant='body2' color='primary'><i className='fad fa-sign-in fa-2x'></i></Typography>
                                            </Box>
                                        }
                                        {
                                            item.salida ?
                                            <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                <Typography variant='body2'>Fecha de salida: </Typography>
                                                <Typography variant='body2' style={{margin: '0px 12px'}} color='secondary'>{getDate(item.salida.fechaDeSalida, 'DDDD')}</Typography>
                                            </Box> :
                                            <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                <Typography variant='body2'>Fecha de entrada: </Typography>
                                                <Typography variant='body2' style={{margin: '0px 12px'}} color='primary'>{getDate(item.entrada.fechaDeEntrada, 'DDDD')}</Typography>
                                            </Box>
                                        }
                                        {
                                            item.salida ?
                                            <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                <Typography variant='body2'>Cliente: </Typography>
                                                <Typography variant='body2' style={{margin: '0px 12px'}} color='secondary'>{item.salida.cliente}</Typography>
                                            </Box> :
                                            <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                <Typography variant='body2'>Proveedor: </Typography>
                                                <Typography variant='body2' style={{margin: '0px 12px'}} color='primary'>{item.entrada.proveedor}</Typography>
                                            </Box>
                                        }
                                        <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                            <Typography variant='body2'>Motivo: </Typography>
                                            <Typography variant='body2' style={{margin: '0px 12px'}} color={`${item.salida ? 'secondary' : 'primary'}`}>{item.motivo}</Typography>
                                        </Box>
                                        <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                            <Typography variant='body2'># Movimiento de inventario: </Typography>
                                            <Typography variant='body2' style={{margin: '0px 12px'}} color={`${item.salida ? 'secondary' : 'primary'}`}>{item.noMovimiento}</Typography>
                                        </Box>
                                        {
                                            item.salida ?
                                            <>
                                                <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                    <Typography variant='body2'>Solicita: </Typography>
                                                    <Typography variant='body2' style={{margin: '0px 12px'}} color='secondary'>{item.salida.solicitante}</Typography>
                                                </Box>
                                                <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                    <Typography variant='body2'>Recibe: </Typography>
                                                    <Typography variant='body2' style={{margin: '0px 12px'}} color='secondary'>{item.salida.recibe}</Typography>
                                                </Box>
                                            </>
                                            :
                                            <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                <Typography variant='body2'>Recibe: </Typography>
                                                <Typography variant='body2' style={{margin: '0px 12px'}} color='primary'>{item.entrada.recibe}</Typography>
                                            </Box>
                                        }
                                        <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                            <Typography variant='body2'>Entrega: </Typography>
                                            <Typography variant='body2' style={{margin: '0px 12px'}} color={item.entrada ? 'primary' : 'secondary'}>{item.entrada ? item.entrada.entrega : item.salida.entrega}</Typography>
                                        </Box>
                                        <Grid container>
                                            <Grid item sm={12}>

                                                <TableContainer>
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow hover >
                                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em', backgroundColor: '#C147E911' }} colSpan={4}>Detalles</TableCell>
                                                            </TableRow>
                                                            <TableRow hover sx={{backgroundColor: 'comp.tableHeaderBg'}}>
                                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cantidad</TableCell>
                                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Descripcion</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {item.productos.map((ref, i) => (
                                                                <TableRow hover key={i} sx={{backgroundColor: `${ref.id !== product._id ? 'comp.tableBg': '#47A99222'}`}}>
                                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidad}</TableCell>
                                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.descripcion}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>

                                                <br />
                                            </Grid>               
                                        </Grid>
                                    </Box>
                            ))}
                    </Container>
                )
            } else {
                return(
                    <Container maxWidth='xxl'>
                        <Typography variant='h4' style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 700 }}>Movimientos del producto</Typography>

                        {productDetails()}

                        <Divider className='my-3' textAlign="left">
                            <CustomChip variant='outlined' estatus='AUTORIZADO' label='Detalles del movimiento' className='text-bold' />
                        </Divider>
                        <Typography variant='h6' style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 400 }}>No hay movimientos registrados del producto</Typography>
                    </Container>
                )
            }
        }
    }

    return(
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>

            {renderHistory()}
            <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
        </Container>
    )
}

export default SeguimientoProducto;